import {
  List,
  Datagrid,
  TextField,
  BooleanField,
  EditButton,
  DeleteButton,
  ReferenceField,
  NumberField,
} from 'react-admin';

export const CharacteristicList = () => (
  <List>
    <Datagrid>
      <TextField source="name" />
      <TextField source="slug" />
      <ReferenceField source="groupId" reference="characteristic-groups" link="show">
        <TextField source="name" />
      </ReferenceField>
      <TextField source="unit" />
      <NumberField source="sortOrder" />
      <BooleanField source="isActive" />
      <EditButton />
      <DeleteButton mutationMode="pessimistic" />
    </Datagrid>
  </List>
);
